import {getDateOnly} from '../middleware/dateControl';
import { useState } from "react";
import s from './SmallCalendar.module.css';
import moment from 'moment';


export default function SmallCalendar(prop) {	
	const NoBox = () => {		return (<div className={s['no-box']}>&#9632;</div>);}
	const NormalBox = () => {		return (<div className={s['normal-box']}>&#9632;</div>);}
	const RedBox = () => {		return (<div className={s['red-box']}>&#9632;</div>);}
	const TargetBox = () => {		return (<div className={s['target-box']}>&#9632;</div>);}

	const Box = (props) => {
		switch (props.type) {
			case 1:
				return (<NoBox/>);
			case 2:
				return (<NormalBox/>);
			case 3:
				return (<RedBox/>);
			case 4:
				return (<TargetBox/>);
		}
	}

	const [date] = useState(getDateOnly(prop.date));
	
	
	/*
	number of date, 
	start week of 1st day
	current date
	
	*/
	
	let todayDisplay = moment(date, 'YYYY-MM-DD HH:mm:ss').format('MMM YYYY');
	
	let today = moment(date, 'YYYY-MM-DD HH:mm:ss').format('D');
	let firstDay = moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-') + "01";
	let lastDayDay = moment(date, 'YYYY-MM-DD HH:mm:ss').endOf('month').format('DD');
	let lastDayToWeekDay = moment(date, 'YYYY-MM-DD HH:mm:ss').endOf('month').isoWeekday()
	let firstDayToWeekDay = moment(firstDay, 'YYYY-MM-DD').isoWeekday()
	
	if (firstDayToWeekDay == 7) {
		firstDayToWeekDay = 0;
	}
	
	const twoDArray = [];
	
	let aa = [];
	if (firstDayToWeekDay != 0) {		
		for (let i=0; i<firstDayToWeekDay; i++) {
			aa.push(1);
		}
	}
	
	for (let i=0, j=firstDayToWeekDay; i<lastDayDay; i++, j++) {
		
		if (j == 7) {
			twoDArray.push(aa);
			aa = [];
			j=0;
		}
		
		if (i+1 == today) {
			aa.push(4);
		} else if (j == 0) {
			aa.push(3);
		} else {
			aa.push(2);
		}
		
		
	}
	
	if (lastDayToWeekDay != 6) {
			twoDArray.push(aa);
			aa = [];
	}
	
	
	
	
	return (<div className={s['container']}>
	
		
		{
		twoDArray.map((r, indexR)=>(<div key={indexR} className={s['row']}>
			{
				<>{r.map((rd, indexRd)=>
					(<span key={indexRd}>
						<Box type={rd}/>
					</span>
					)
				)}</>
				
			}
		</div>))
		}
		
			<div className={s['date-display']}>
			{todayDisplay}
			</div>
	
	</div>);
	/*
	let html = "";
	
	if (firstDayToWeekDay != 1) {
		html += `<div className={[s['first-row'], s['row']].join(' ')}>`;
		for (let i=1; i<firstDayToWeekDay; i++) {
			html += `<div className={s['no-box']}>&#9632;</div>`;
		}
	}
	
	for (let i=0, j=firstDayToWeekDay; i<lastDayDay; i++, j++) {
		if (j == 1) {
			html += `<div className={s['row']}>`;
		}
		
		html += `<div className={s['normal-box']}>&#9632;</div>`;
		
		if (j == 7) {
			j=0;
			html += `</div>`;
		}
		
		
	}
	
	if (lastDayToWeekDay != 7) {
		html += `</div>`;
	}*/
	
	/*
	html += (<><div className={[s['first-row'], s['row']].join(' ')}>
				<div className={s['no-box']}>&#9632;</div>
				<div className={s['no-box']}>&#9632;</div>
				<div className={s['no-box']}>&#9632;</div>
				<div className={s['no-box']}>&#9632;</div>
				<div className={s['no-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
			</div>
			<div className={s['row']}>
				<div className={s['red-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
				<div className={s['target-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
			</div>
			<div className={[s['last-row'], s['row']].join(' ')}>
				<div className={s['red-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
				<div className={s['normal-box']}>&#9632;</div>
			</div></>)*/
	
	
	
	/*let htmlString = `<div className={s['container']}>` + html + `</div>`
	
  const reactElement = parse(htmlString);
	console.log(reactElement);*/
}